import { GlobalThemeOverrides } from 'naive-ui';

import darkThemeOverridesJson from './dark-theme-overrides.json';

export const darkThemeOverrides: GlobalThemeOverrides = darkThemeOverridesJson;
export const lightThemeOverride: GlobalThemeOverrides = {};
